import { render, staticRenderFns } from "./toonatar.vue?vue&type=template&id=8889af9e&scoped=true&lang=pug&"
import script from "./toonatar.vue?vue&type=script&lang=js&"
export * from "./toonatar.vue?vue&type=script&lang=js&"
import style0 from "./toonatar.vue?vue&type=style&index=0&id=8889af9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8889af9e",
  null
  
)

export default component.exports